import createWithBsPrefix from './utils/createWithBsPrefix';

export default createWithBsPrefix('carousel-caption', {
  Component: 'div',
});
